/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { FadeOutEffect } from "./FadeOutEffect";
import { PlaylistClip } from "types/Clip";
import { BlockTypes } from "constants/BlockTypes";
import { LONG_FADE_DURATION_MS } from "PhonosConstants";

export class LongFadeOutEffect extends FadeOutEffect {
  static canBuildFor(clip: PlaylistClip): boolean {
    return clip.type === BlockTypes.WAVEFORM && clip.fadeOut;
  }

  constructor(
    audioContext: AudioContext,
    clip: PlaylistClip,
    playlistTime: number
  ) {
    super(audioContext, clip, playlistTime, LONG_FADE_DURATION_MS);
  }
}
